import { render } from "./CreateStoryCard.vue?vue&type=template&id=503c00ae&scoped=true"
import script from "./CreateStoryCard.vue?vue&type=script&lang=js"
export * from "./CreateStoryCard.vue?vue&type=script&lang=js"

import "./CreateStoryCard.vue?vue&type=style&index=0&id=503c00ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.107.1_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503c00ae"]])

export default __exports__